import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import React, { useState } from "react"; // Import hooks
import { HelmetProvider } from "react-helmet-async";
import Home from './pages/Home';
import InglesPresencial from "./pages/ingles-presencial";
import About from './pages/About';
import Contact from './pages/Contact';
import './style.css';
import InglesOnline from './pages/ingles-online';
import Linguahub from './pages/LinguaHub';
import Cursos from './pages/Cursos';
import CertificacionesIngles from "./pages/Certificaciones-Ingles";
import ExamenUbicacion from "./pages/ExamenUbicacion";
import PlacementTest from "./pages/PlacementTest";
import AboutUs from "./pages/AboutUs";
import SpanishClasses from "./pages/SpanishClasses";
import SummerCamp from "./pages/SummerCamp";
import SpanishFees from "./pages/SpanishFees";
import Services from "./pages/Services";
import OurLocation from "./pages/OurLocation";
import Kinder from "./pages/courses/Kinder";
import Ninos from "./pages/courses/Ninos";
import Jovenes from "./pages/courses/Jovenes";
import Adultos from "./pages/courses/Adultos";
import Intensivo from "./pages/courses/Intensivo";
import Privadas from "./pages/courses/Privadas";
import Empresas from "./pages/courses/Empresas";
import Certificaciones from "./pages/courses/Certificaciones";
import ScrollToTop from "./ScrollToTop";
import CourseFinderForm from "./pages/CourseFinderForm";
import PartnerWithUsSpanish from "./PartnerWithUsSpanish";
import Gracias from "./components/Gracias";



export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  // Function to toggle the menu visibility
  const handleMenuToggle = () => setMenuOpen(!menuOpen);

  // Function to close the menu after clicking a link
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <div className="app-container">
    <HelmetProvider>
    <Router>
    <ScrollToTop />
    <nav className="navbar">
          {/* Home Logo */}
          <Link to="/" className="home-button">
            <img src="/logo.webp" alt="Home" className="home-logo" />
          </Link>

          {/* Mobile Menu Button */}
          <button 
            className="menu-button" 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu" /* ✅ Fix: Improve accessibility */
          >
            ☰
          </button>

          {/* Menu Items */}
          <div className={`menu-items ${menuOpen ? "open" : ""}`}>
            <div className="menu-item">
              <Link to="/" onClick={handleLinkClick} className="hover:underline">Aprende Inglés</Link>
              <div className="submenu">
                <Link to="/" onClick={handleLinkClick} className="submenu-link">Presencial</Link>
                <Link to="/ingles-online" onClick={handleLinkClick} className="submenu-link">Online</Link>
                <Link to="/Certificaciones-Ingles" onClick={handleLinkClick} className="submenu-link">Certificaciones</Link>
                <Link to="/Examen-de-ubicacion" onClick={handleLinkClick} className="submenu-link">Examen de Ubicación</Link>
                <Link to="/EncuentraTuCurso" onClick={handleLinkClick} className="submenu-link">Encuentra Tu Curso</Link>
              </div>
            </div>
            <div className="menu-item">
              <Link to="/Spanish" onClick={handleLinkClick} className="hover:underline">Learn Spanish</Link>
              <div className="submenu">
                <Link to="/AboutUs" onClick={handleLinkClick} className="submenu-link">About Us</Link>
                <Link to="/Spanish" onClick={handleLinkClick} className="submenu-link">Classes</Link>
                <Link to="/Spanish-Fees" onClick={handleLinkClick} className="submenu-link">Fees</Link>
                <Link to="/Placement-Test" onClick={handleLinkClick} className="submenu-link">Placement Test</Link>
                <Link to="/Services" onClick={handleLinkClick} className="submenu-link">Services</Link>
                <Link to="/PartnerWithUsSpanish" onClick={handleLinkClick} className="submenu-link">Partner With Us</Link>
                <Link to="/OurLocation" onClick={handleLinkClick} className="submenu-link">Our Location</Link>
              </div>
            </div>
            <Link to="/Cursos" onClick={handleLinkClick} className="hover:underline">Cursos</Link>
            <Link to="/SummerCamp" onClick={handleLinkClick} className="hover:underline">Curso de Verano</Link>
            <Link to="/LinguaHub" onClick={handleLinkClick} className="hover:underline">LinguaHub</Link>
            <Link to="/Sobre-Nosotros" onClick={handleLinkClick} className="hover:underline">Sobre Nosotros</Link>
            
            <div className="menu-item">
            <Link to="/contacto" className="nav-cta hover:underline">Contáctanos</Link>
              <div className="submenu">
                <Link to="/contacto" onClick={handleLinkClick} className="submenu-link">Contáctanos</Link>
                <Link to="/work-with-us" onClick={handleLinkClick} className="submenu-link">Trabaja con nosotros</Link>
              </div>
            </div>
          </div>
        </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/" element={<InglesPresencial />} />
        <Route path="/ingles-online" element={<InglesOnline />} />
        <Route path="/Certificaciones-Ingles" element={<CertificacionesIngles />} />
        <Route path="/LinguaHub" element={<Linguahub />} />
        <Route path="/ingles-presencial/Certificaciones" element={<CertificacionesIngles />} />
        <Route path="/Examen-de-ubicacion" element={<ExamenUbicacion />} />
        <Route path="/SummerCamp" element={<SummerCamp />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Our-Location" element={<ExamenUbicacion />} />
        <Route path="/Placement-Test" element={<PlacementTest />} />
        <Route path="/Sobre-Nosotros" element={<About />} />
        <Route path="/Spanish" element={<SpanishClasses />} />
        <Route path="/Spanish-Fees" element={<SpanishFees />} />
        <Route path="/PartnerWithUsSpanish" element={<PartnerWithUsSpanish />} />
        <Route path="/OurLocation" element={<OurLocation />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/Cursos" element={<Cursos />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/courses/Kinder" element={<Kinder />} />
        <Route path="/courses/Ninos" element={<Ninos />} />
        <Route path="/courses/Jovenes" element={<Jovenes />} />
        <Route path="/courses/Adultos" element={<Adultos />} />
        <Route path="/courses/Intensivo" element={<Intensivo />} />
        <Route path="/courses/Privadas" element={<Privadas />} />
        <Route path="/courses/Empresas" element={<Empresas />} />
        <Route path="/courses/PreparacionExamen" element={<Certificaciones />} />
        <Route path="/EncuentraTuCurso" element={<CourseFinderForm />} />
        <Route path="/gracias" element={<Gracias />} />
        <Route path="https://www.linguahub.culturlingua.com"/>
      </Routes>
    </Router>
    
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <span className="footer-brand-logo">Cultur<span>lingua</span></span>
              <p>Más de 20 años formando hablantes reales de inglés en Jalisco. Presencial en Tlaquepaque y online desde cualquier lugar.</p>
              <div className="footer-social">
                <a href="https://www.facebook.com/Culturlinguagdl" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <img src="/facebook-icon.png" alt="Facebook" />
                </a>
                <a href="https://www.instagram.com/culturlingua_gdl/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <img src="/instagram-icon.png" alt="Instagram" />
                </a>
                <a href="https://www.linkedin.com/company/culturlingua-gdl/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <img src="/linkedin-icon.png" alt="LinkedIn" />
                </a>
              </div>
            </div>
            <div className="footer-col">
              <h4>Inglés</h4>
              <a href="/Cursos">Cursos Presenciales</a>
              <a href="/ingles-online">Clases Online</a>
              <a href="/courses/Empresas">Para Empresas</a>
              <a href="/Certificaciones-Ingles">Certificaciones</a>
              <a href="/Examen-de-ubicacion">Examen de Ubicación</a>
            </div>
            <div className="footer-col">
              <h4>Español</h4>
              <a href="/Spanish">Clases de Español</a>
              <a href="/Spanish-Fees">Precios</a>
              <a href="/Placement-Test">Placement Test</a>
              <a href="/OurLocation">Nuestra Ubicación</a>
            </div>
            <div className="footer-col">
              <h4>Institución</h4>
              <a href="/Sobre-Nosotros">Sobre Nosotros</a>
              <a href="/contacto">Contacto</a>
              <a href="/LinguaHub">LinguaHub</a>
              <a href="/SummerCamp">Curso de Verano</a>
              <a href="/work-with-us">Trabaja con Nosotros</a>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2025 Culturlingua. Todos los derechos reservados.</span>
            <span>📍 Reforma 31, Tlaquepaque, Jalisco · 📞 +52 33 3344 9139</span>
          </div>
        </div>
      </footer>
    
   <a href="https://wa.me/5213333449139?text=Hola%2C%20quisiera%20más%20información%20sobre%20los%20cursos." class="whatsapp-float" target="_blank" aria-label="Chat on WhatsApp">
  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
</a>
</HelmetProvider>
      </div>

      

    
  );
}
